import { useDispatch, useSelector } from 'react-redux';
import css from './TopPart.module.css';
import { useEffect } from 'react';
import { getMechanicBalance } from '../../redux/auth/operations';
import { selectBalance, selectUser } from '../../redux/auth/selectors';
import { selectCars } from '../../redux/cars/selectors';

export default function TopPart() {
  const dispatch = useDispatch();

  const balance = useSelector(selectBalance);
  const user = useSelector(selectUser);
  const cars = useSelector(selectCars);
  // console.log('balance', balance);
  // console.log('user', user);

  const completedCars = cars.filter(
    car =>
      car?.status === 'completed' &&
      car?.complete_date?.split('T')[0] ===
        new Date().toISOString().split('T')[0]
  );

  // console.log( new Date().toISOString().split('T')[0]);
  // console.log();

  // console.log("completedCars",completedCars);

  const otherCars = cars?.filter(car => car?.status !== 'completed');

  const wage = completedCars.reduce(
    (sum, i) => sum + Number(i.earning || 0),
    0
  );
  const possibleSalary = otherCars.reduce(
    (sum, i) => sum + Number(i.earning || 0),
    0
  );
  // console.log('possibleSalary', possibleSalary);
  // console.log('wage', wage);

  return (
    <div className={css.topPart}>
      <div className={css.mechNameBox}>
        <p className={css.name}>{`${user?.first_name} ${user?.last_name}`}</p>
        <p className={css.paleText}>Механік</p>
      </div>
      <div className={css.salaryInfoBox}>
        <div className={css.salaryPoint}>
          <p className={css.paleText}>Нараховано</p>
          <p className={css.amount}>{balance?.total_earned ?? '0'}</p>
        </div>
        <div className={css.salaryPoint}>
          <p className={css.paleText}>Сьогодні</p>
          <p className={css.amount}>
            +{' '}
            {Number(balance?.today_earned) !== 0
              ? balance?.today_earned
              : Number(wage) !== 0
                ? Math.trunc(wage)
                : 0}
          </p>
        </div>
        <div className={css.salaryPoint}>
          <p className={css.paleText}>Можлива ЗП</p>
          <p className={css.amountPossible}>
            {Number.isFinite(balance?.potential_earned) &&
            Number(balance?.potential_earned !== 0)
              ? Math.trunc(balance.potential_earned)
              : Number(possibleSalary) !== 0
                ? Math.trunc(possibleSalary)
                : '0'}
          </p>
        </div>
      </div>
    </div>
  );
}
